const DEBOUNCE_DELAYS = {
	ADJUST_BUTTON: 150,
	QUANTITY_INPUT: 300,
	OBSERVER: 200,
};

window.customer = window.customer || { slowClick: 0 };

class QuickBuy {
	constructor() {
		this.addingDisplay = document.querySelector(".addingtocartshow");
		this.initQty();
		this.initQtyInput();
		this.initializeCartQuantities();
	}

	get isSlowClick() {
		return window.customer.slowClick === 1;
	}

	async initializeCartQuantities() {
		try {
			const response = await fetch(`${theme.routes.cart_update_url}.js`);
			const cart = await response.json();

			cart.items.forEach((item) => {
				const quantityInput = document.querySelector(
					`.quickbuy .quantity[data-id="${item.variant_id}"]`,
				);

				if (!quantityInput) return;

				if (Number(quantityInput.value) > 0) {
					this.qtyState(quantityInput.closest(".quickbuy"), Number(quantityInput.value));
				}
			});
		} catch (error) {
			console.error("Error fetching cart:", error);
		}
	}

	initQty() {
		document
			.querySelectorAll('.adjust:not([data-listener="true"])')
			.forEach((adjustButton) => {
				let timeout;
				adjustButton.setAttribute("data-listener", "true");

				adjustButton.addEventListener("click", () => {
					const updateValue = Number(adjustButton.getAttribute("data-update"));
					const quickbuyElement = adjustButton.closest(".quickbuy");
					const quantityInput = quickbuyElement.querySelector(".quantity");
					const maxQuantity = Number(quantityInput.getAttribute("data-max"));
					let newValue = Number(quantityInput.value) + updateValue;

					if (newValue > maxQuantity && updateValue > 0) return;
					if (newValue < 0) newValue = 0;

					quantityInput.value = newValue;
					this.qtyState(quickbuyElement, newValue);
					this.updateMaxState(quickbuyElement, newValue, updateValue, maxQuantity);

					clearTimeout(timeout);
					timeout = window.setTimeout(() => {
						this.showLoadingState(quantityInput.dataset.adjust);
						this.createFormData(
							quantityInput.dataset.id,
							newValue,
							quantityInput.dataset.type,
							quantityInput.dataset.key,
							quantityInput.dataset.adjust,
						);
					}, DEBOUNCE_DELAYS.ADJUST_BUTTON);
				});
			});
	}

	showLoadingState(adjust) {
		if (this.isSlowClick) {
			document.querySelectorAll(".quickbuy").forEach((el) => el.classList.add("disabled"));
			this.addingDisplay.style.display = "block";
		}
		if (adjust === "cart") {
			document.querySelector(".cart-drawer--loading")?.classList.add("active");
		}
	}

	hideLoadingState() {
		if (this.isSlowClick) {
			document.querySelectorAll(".quickbuy").forEach((el) => el.classList.remove("disabled"));
			this.addingDisplay.style.display = "none";
		}
	}

	updateMaxState(quickbuyElement, value, updateValue, maxQuantity) {
		if (value + updateValue > maxQuantity) {
			quickbuyElement.classList.add("max");
		} else {
			quickbuyElement.classList.remove("max");
		}
	}

	async createFormData(variantId, quantity, type, key, adjust) {
		let formData;
		let totalQuantity = 0;

		if (type === "generic") {
			formData = { updates: { [variantId]: quantity } };
			totalQuantity = quantity;
		} else if (type === "deal") {
			try {
				const cartResponse = await fetch("/cart.js");
				const cartData = await cartResponse.json();
				let updates = {};
				let itemFound = false;
				let itemUpdated = false;

				if (adjust === "cart") {
					cartData.items?.forEach((item) => {
						if (item.variant_id === Number(variantId) && item.key !== key) {
							totalQuantity += item.quantity;
						}
					});
				}

				totalQuantity += quantity;

				cartData.items?.forEach((item) => {
					if (item.variant_id === Number(variantId)) {
						itemUpdated = true;
						if (itemFound) {
							updates[item.key] = 0;
						} else {
							updates[item.key] = totalQuantity;
							itemFound = true;
						}
					}
				});

				if (!itemUpdated) {
					updates = { [variantId]: quantity };
				}

				formData = { updates };
			} catch (error) {
				console.error("Error building deal form data:", error);
				return;
			}
		}

		if (!formData) return;

		this.updateLineItem(formData, adjust);
		this.variantUpdates(totalQuantity, variantId);
	}

	async updateLineItem(formData, adjust = "") {
		try {
			const response = await fetch("/cart/update.js", {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(formData),
			});

			if (!response.ok) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}

			await response.json();
			this.hideLoadingState();

			document.documentElement.dispatchEvent(
				new CustomEvent("cart:refresh", { bubbles: true }),
			);
		} catch (error) {
			console.error("Error updating cart:", error);
		}
	}

	variantUpdates(totalQuantity, variantId) {
		document
			.querySelectorAll(`[data-id="${variantId}"]`)
			.forEach((quantityInput) => {
				if (quantityInput.dataset.adjust === "cart") return;

				quantityInput.value = totalQuantity;
				const quickbuyElement = quantityInput.closest(".quickbuy");

				if (totalQuantity === 0) {
					quickbuyElement.classList.remove("active");
				}

				const plusButton = quantityInput.nextElementSibling;
				if (!plusButton) return;

				const updateValue = Number(plusButton.dataset.update);
				const maxQuantity = Number(quantityInput.dataset.max);
				this.updateMaxState(quickbuyElement, totalQuantity, updateValue, maxQuantity);
			});
	}

	qtyState(quickbuyElement, quantity) {
		const isActive = quantity > 0;
		const minus = quickbuyElement.querySelector(".minus");
		const plus = quickbuyElement.querySelector(".plus");
		quickbuyElement.classList.toggle("active", isActive);
		minus?.classList.toggle("active", isActive);
		plus?.classList.toggle("active", isActive);
	}

	initQtyInput() {
		document
			.querySelectorAll('input.quantity:not([data-listener="true"])')
			.forEach((quantityInput) => {
				let timeout;
				quantityInput.setAttribute("data-listener", "true");

				quantityInput.addEventListener("input", (event) => {
					const maxQuantity = Number(quantityInput.getAttribute("data-max"));
					const updateValue = Number(
						quantityInput.nextElementSibling?.getAttribute("data-update") ?? 1,
					);
					let inputValue = Number(event.target.value);
					const quickbuyElement = quantityInput.closest(".quickbuy");

					this.updateMaxState(quickbuyElement, inputValue, updateValue, maxQuantity);

					if (inputValue < 1) {
						this.qtyState(quickbuyElement, 0);
					}

					clearTimeout(timeout);
					timeout = window.setTimeout(() => {
						if (inputValue < 0) inputValue = 0;
						if (inputValue > maxQuantity) inputValue = maxQuantity;

						const remainder = inputValue % updateValue;
						if (remainder) {
							const rounded = inputValue + (updateValue - remainder);
							inputValue = rounded > maxQuantity ? inputValue - remainder : rounded;
						}

						quantityInput.value = inputValue;

						this.createFormData(
							quantityInput.getAttribute("data-id"),
							inputValue,
							quantityInput.getAttribute("data-type"),
							quantityInput.getAttribute("data-key"),
							quantityInput.getAttribute("data-adjust"),
						);
					}, DEBOUNCE_DELAYS.QUANTITY_INPUT);
				});

				quantityInput.addEventListener("focusout", () => {
					if (!quantityInput.value || quantityInput.value === "0") {
						quantityInput.closest(".quickbuy").classList.remove("active");
					}
				});
			});
	}
}

function observeElementsWithRateLimit(selector, callback, delay = 300) {
	const elements = new Set();
	let timeoutId = null;

	const processElements = () => {
		if (elements.size > 0) {
			callback(Array.from(elements));
			elements.clear();
		}
	};

	const observer = new MutationObserver(() => {
		document.querySelectorAll(selector).forEach((element) => {
			if (!element._observed) {
				element._observed = true;
				elements.add(element);
			}
		});

		clearTimeout(timeoutId);
		timeoutId = setTimeout(processElements, delay);
	});

	observer.observe(document.body, { childList: true, subtree: true });
}

observeElementsWithRateLimit(".quickbuy", () => new QuickBuy(), DEBOUNCE_DELAYS.OBSERVER);

document.addEventListener("DOMContentLoaded", () => new QuickBuy());
